import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, SvgIcon, TextField } from '@material-ui/core';
import { Search as SearchIcon, X } from 'react-feather';

const SearchInput = ({
  value = '',
  onChange,
  onSearch,
  onKeyDown,
  placeholder = 'Tìm kiếm...',
  className,
  size = 'small',
  variant = 'outlined',
  ...rest
}) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13 && onSearch) {
      onSearch(event.target.value);
    }
    onKeyDown?.(event);
  };

  const handleClear = () => {
    onChange?.('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      className={className}
      variant={variant}
      size={size}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SvgIcon fontSize="small" color="action">
              <SearchIcon />
            </SvgIcon>
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <SvgIcon
              fontSize="small"
              color="action"
              style={{ cursor: 'pointer' }}
              onClick={handleClear}
            >
              <X />
            </SvgIcon>
          </InputAdornment>
        ),
        style: {
          fontSize: '14px'
        }
      }}
      placeholder={placeholder}
      {...rest}
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string
};

export default SearchInput;
